/**
 * Green Brothers store locator.
 * Magasins via data-stores-url (asset JSON du Sheet, ou Apps Script /exec).
 * Mock seulement si l’URL est vide.
 */
(() => {
  if (customElements.get('gb-store-locator')) return;

  const MONTREAL = { lat: 45.526, lng: -73.58, label: 'Montréal' };

  const FSA = {
    H1A: [45.672, -73.503],
    H1B: [45.632, -73.508],
    H1C: [45.65, -73.548],
    H1E: [45.628, -73.595],
    H1G: [45.6, -73.625],
    H1H: [45.585, -73.64],
    H1J: [45.608, -73.555],
    H1K: [45.598, -73.545],
    H1L: [45.59, -73.52],
    H1M: [45.575, -73.545],
    H1N: [45.565, -73.53],
    H1P: [45.595, -73.58],
    H1R: [45.59, -73.595],
    H1S: [45.58, -73.575],
    H1T: [45.568, -73.555],
    H1V: [45.545, -73.535],
    H1W: [45.545, -73.555],
    H1X: [45.557, -73.568],
    H1Y: [45.55, -73.575],
    H1Z: [45.565, -73.61],
    H2A: [45.562, -73.607],
    H2B: [45.575, -73.64],
    H2C: [45.56, -73.655],
    H2E: [45.548, -73.615],
    H2G: [45.54, -73.595],
    H2H: [45.533, -73.568],
    H2J: [45.527, -73.58],
    H2K: [45.53, -73.545],
    H2L: [45.521, -73.555],
    H2M: [45.555, -73.645],
    H2N: [45.545, -73.65],
    H2P: [45.555, -73.628],
    H2R: [45.545, -73.62],
    H2S: [45.535, -73.605],
    H2T: [45.525, -73.595],
    H2V: [45.52, -73.608],
    H2W: [45.52, -73.58],
    H2X: [45.515, -73.57],
    H2Y: [45.507, -73.554],
    H2Z: [45.505, -73.561],
    H3A: [45.504, -73.575],
    H3B: [45.5, -73.568],
    H3C: [45.49, -73.56],
    H3E: [45.47, -73.545],
    H3G: [45.498, -73.58],
    H3H: [45.492, -73.585],
    H3J: [45.485, -73.575],
    H3K: [45.48, -73.56],
    H3L: [45.555, -73.67],
    H3M: [45.535, -73.68],
    H3N: [45.53, -73.63],
    H3P: [45.525, -73.65],
    H3R: [45.51, -73.65],
    H3S: [45.505, -73.63],
    H3T: [45.5, -73.62],
    H3V: [45.495, -73.605],
    H3W: [45.49, -73.63],
    H3X: [45.48, -73.63],
    H3Y: [45.485, -73.6],
    H3Z: [45.485, -73.59],
    H4A: [45.473, -73.61],
    H4B: [45.465, -73.63],
    H4C: [45.478, -73.585],
    H4E: [45.455, -73.59],
    H4G: [45.46, -73.57],
    H4H: [45.445, -73.575],
    H4J: [45.535, -73.71],
    H4K: [45.525, -73.73],
    H4L: [45.515, -73.68],
    H4M: [45.5, -73.68],
    H4N: [45.53, -73.68],
    H4P: [45.495, -73.655],
    H4R: [45.51, -73.71],
    H4S: [45.49, -73.74],
    H4T: [45.47, -73.75],
    H4V: [45.47, -73.65],
    H4W: [45.465, -73.665],
    H4X: [45.45, -73.65],
    H4Y: [45.458, -73.75],
    H7A: [45.62, -73.7],
    H7G: [45.56, -73.69],
    H7N: [45.56, -73.71],
    H7T: [45.57, -73.75],
    H8N: [45.43, -73.62],
    H8S: [45.44, -73.75],
    H9A: [45.5, -73.82],
    H9B: [45.48, -73.8],
    H9H: [45.45, -73.83],
    H9P: [45.46, -73.74],
    H9R: [45.48, -73.8],
    H9S: [45.44, -73.75],
    H9W: [45.433, -73.865],
    J3B: [45.307, -73.254],
    J3Y: [45.5, -73.43],
    J4K: [45.527, -73.518],
    J4W: [45.48, -73.47],
    J5R: [45.38, -73.51],
    J6A: [45.7, -73.65],
    J6W: [45.7, -73.64],
    J7C: [45.67, -73.88],
    J7V: [45.4, -74.03],
    J8X: [45.429, -75.724],
    G1R: [46.813, -71.208],
    G1V: [46.78, -71.28],
    G1X: [46.77, -71.32],
    G2B: [46.86, -71.3],
    J1H: [45.404, -71.892],
  };

  const POSTAL_GEO_CACHE = {};

  const LETTER_FALLBACK = {
    A: [47.56, -52.71],
    B: [44.65, -63.57],
    C: [46.24, -63.13],
    E: [45.96, -66.64],
    G: [46.81, -71.21],
    H: [45.52, -73.58],
    J: [45.5, -73.45],
    K: [45.42, -75.7],
    L: [43.65, -79.38],
    M: [43.7, -79.4],
    N: [43.0, -81.2],
    P: [46.5, -80.99],
  };

  const LIST_LIMIT = 40;
  const storeRequests = new Map();

  const MOCK_STORES = [
    {
      id: 'rachelle-rosemont',
      name: 'Rachelle-Béry Rosemont',
      banner: 'Rachelle-Béry',
      channel: 'health',
      address: '4810 Rue de Bellechasse',
      city: 'Montréal',
      postal: 'H1X 2J2',
      lat: 45.5475,
      lng: -73.5778,
      hours: '9h-19h',
      openHour: 9,
      closeHour: 19,
      products: ['saucisse', 'popcorn', 'pizza'],
    },
    {
      id: 'iga-duchemin',
      name: 'IGA Extra Famille Duchemin',
      banner: 'IGA',
      channel: 'grocery',
      address: '6700 Rue Saint-Denis',
      city: 'Montréal',
      postal: 'H2S 2S3',
      lat: 45.5358,
      lng: -73.6124,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse', 'pizza', 'burger'],
    },
    {
      id: 'metro-jeantalon',
      name: 'Metro Plus Jean-Talon',
      banner: 'Metro',
      channel: 'grocery',
      address: '305 Rue Jean-Talon E',
      city: 'Montréal',
      postal: 'H2R 1S9',
      lat: 45.5396,
      lng: -73.6142,
      hours: '8h-22h',
      openHour: 8,
      closeHour: 22,
      products: ['saucisse', 'popcorn'],
    },
    {
      id: 'avril-stlaurent',
      name: 'Avril Supermarché Santé',
      banner: 'Avril',
      channel: 'health',
      address: '3685 Boul. Saint-Laurent',
      city: 'Montréal',
      postal: 'H2X 2V5',
      lat: 45.5164,
      lng: -73.5759,
      hours: '9h-20h',
      openHour: 9,
      closeHour: 20,
      products: ['saucisse', 'popcorn', 'pizza', 'burger'],
    },
    {
      id: 'tau-plateau',
      name: 'Marché Tau',
      banner: 'Tau',
      channel: 'health',
      address: '4238 Rue Saint-Denis',
      city: 'Montréal',
      postal: 'H2J 2K8',
      lat: 45.5233,
      lng: -73.5867,
      hours: '9h-19h',
      openHour: 9,
      closeHour: 19,
      products: ['popcorn', 'pizza'],
    },
    {
      id: 'iga-gagnon',
      name: 'IGA Famille Gagnon',
      banner: 'IGA',
      channel: 'grocery',
      address: '2950 Boul. Rosemont',
      city: 'Montréal',
      postal: 'H1Y 1M4',
      lat: 45.5508,
      lng: -73.5821,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse', 'burger'],
    },
    {
      id: 'marche-vegane',
      name: 'Marché Végane',
      banner: 'Indépendant',
      channel: 'health',
      address: '1821 Rue Sainte-Catherine E',
      city: 'Montréal',
      postal: 'H2K 2H3',
      lat: 45.5221,
      lng: -73.5514,
      hours: '10h-18h',
      openHour: 10,
      closeHour: 18,
      products: ['saucisse', 'popcorn', 'pizza', 'burger'],
    },
    {
      id: 'metro-montroyal',
      name: 'Metro Plus Mont-Royal',
      banner: 'Metro',
      channel: 'grocery',
      address: '1291 Ave du Mont-Royal E',
      city: 'Montréal',
      postal: 'H2J 1Y6',
      lat: 45.5312,
      lng: -73.5784,
      hours: '8h-22h',
      openHour: 8,
      closeHour: 22,
      products: ['saucisse', 'pizza'],
    },
    {
      id: 'maxi-pieix',
      name: 'Maxi Pie-IX',
      banner: 'Maxi',
      channel: 'grocery',
      address: '8500 Boul. Pie-IX',
      city: 'Montréal',
      postal: 'H1Z 3T6',
      lat: 45.5722,
      lng: -73.5941,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse'],
    },
    {
      id: 'iga-longueuil',
      name: 'IGA Extra Chemin de Chambly',
      banner: 'IGA',
      channel: 'grocery',
      address: '2020 Chemin de Chambly',
      city: 'Longueuil',
      postal: 'J4J 3Y7',
      lat: 45.5268,
      lng: -73.4821,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse', 'pizza'],
    },
    {
      id: 'metro-laval',
      name: 'Metro Plus Laval-des-Rapides',
      banner: 'Metro',
      channel: 'grocery',
      address: '533 Boul. Cartier O',
      city: 'Laval',
      postal: 'H7N 2L6',
      lat: 45.5621,
      lng: -73.7078,
      hours: '8h-22h',
      openHour: 8,
      closeHour: 22,
      products: ['saucisse', 'popcorn', 'burger'],
    },
    {
      id: 'iga-lebourgneuf',
      name: 'IGA Extra Lebourgneuf',
      banner: 'IGA',
      channel: 'grocery',
      address: '1400 Boul. Lebourgneuf',
      city: 'Québec',
      postal: 'G2K 2N7',
      lat: 46.8584,
      lng: -71.3072,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse', 'pizza'],
    },
    {
      id: 'avril-ste-foy',
      name: 'Avril Sainte-Foy',
      banner: 'Avril',
      channel: 'health',
      address: '2480 Chemin Sainte-Foy',
      city: 'Québec',
      postal: 'G1V 1T6',
      lat: 46.7862,
      lng: -71.2854,
      hours: '9h-20h',
      openHour: 9,
      closeHour: 20,
      products: ['saucisse', 'popcorn', 'pizza'],
    },
    {
      id: 'metro-sherbrooke',
      name: 'Metro Plus King Ouest',
      banner: 'Metro',
      channel: 'grocery',
      address: '3131 Rue King O',
      city: 'Sherbrooke',
      postal: 'J1L 1C8',
      lat: 45.4048,
      lng: -71.9306,
      hours: '8h-21h',
      openHour: 8,
      closeHour: 21,
      products: ['saucisse'],
    },
    {
      id: 'lufa',
      name: 'Les Fermes Lufa',
      banner: 'Lufa',
      channel: 'online',
      address: 'Panier et points de cueillette',
      city: 'Grand Montréal',
      postal: '',
      lat: 45.5536,
      lng: -73.6389,
      hours: 'Sur commande',
      openHour: 0,
      closeHour: 24,
      products: ['saucisse', 'popcorn', 'pizza', 'burger'],
      url: 'https://montreal.lufa.com/en/marketplace/partner/green-brothers-976',
    },
    {
      id: 'voila',
      name: 'Voilà',
      banner: 'Voilà',
      channel: 'online',
      address: 'Livraison à domicile',
      city: 'Montréal et Québec',
      postal: '',
      lat: 45.5017,
      lng: -73.5673,
      hours: 'Sur commande',
      openHour: 0,
      closeHour: 24,
      products: ['saucisse', 'pizza'],
      url: 'https://voila.ca/categories?brands=Green%20Brothers',
    },
  ];

  const PRODUCT_LABELS = {
    saucisse: 'Saucisses sur bâtonnet',
    minis: 'Minis saucisses',
    popcorn: 'Bouchées',
    pizza: 'Soucoupe pizza',
    burger: 'Soucoupe burger',
  };

  function normalizeSku(raw) {
    const v = String(raw || '')
      .toLowerCase()
      .trim();
    if (!v || v === 'all') return 'all';
    if (v.includes('mini')) return 'minis';
    if (v.includes('pogo') || v.includes('saucisse') || v.includes('baton') || v.includes('corn')) return 'saucisse';
    if (v.includes('popcorn') || v.includes('tofu')) return 'popcorn';
    if (v.includes('pizza')) return 'pizza';
    if (v.includes('burger')) return 'burger';
    if (PRODUCT_LABELS[v]) return v;
    return 'all';
  }

  const POSTAL_RE = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\s?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

  const ONLINE_LINKS = {
    lufa: {
      url: 'https://montreal.lufa.com/fr/marche/partenaire/aliments-green-brothers-976',
      address: 'Panier et points de cueillette',
      city: 'Grand Montréal',
    },
    voila: {
      url: 'https://voila.ca/categories?brands=Green%20Brothers',
      address: 'Livraison à domicile',
      city: 'Montréal et Québec',
    },
  };

  function onlineKind(raw) {
    const blob = `${raw && raw.name} ${raw && raw.banner} ${raw && raw.channel}`.toLowerCase();
    if (blob.includes('lufa')) return 'lufa';
    if (blob.includes('voilà') || blob.includes('voila')) return 'voila';
    if (String(raw && raw.channel) === 'online') return 'online';
    return '';
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit' }).then((res) => {
      if (!res.ok) throw new Error('stores');
      return res.json();
    });
  }

  function fetchJsonp(url) {
    return new Promise((resolve, reject) => {
      const cb = `gbStores_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;
      const script = document.createElement('script');
      const timer = window.setTimeout(() => {
        cleanup();
        reject(new Error('stores-timeout'));
      }, 12000);
      const cleanup = () => {
        window.clearTimeout(timer);
        script.remove();
        try {
          delete window[cb];
        } catch (err) {
          window[cb] = undefined;
        }
      };
      window[cb] = (data) => {
        cleanup();
        resolve(data);
      };
      script.onerror = () => {
        cleanup();
        reject(new Error('stores-jsonp'));
      };
      const join = url.indexOf('?') === -1 ? '?' : '&';
      script.src = `${url}${join}callback=${cb}`;
      document.head.appendChild(script);
    });
  }

  function normalizeApiStore(raw) {
    if (!raw || !raw.name) return null;
    const kind = onlineKind(raw);
    const extra = ONLINE_LINKS[kind];
    const postal = extra ? '' : formatPostal(raw.postal);
    let lat = Number(raw.lat);
    let lng = Number(raw.lng);
    let approx = Boolean(raw.approx);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      if (kind) {
        lat = 45.5017;
        lng = -73.5673;
        approx = true;
      } else {
        const guess = originFromPostal(postal);
        if (!guess) return null;
        lat = guess.lat;
        lng = guess.lng;
        approx = true;
      }
    }
    const products = Array.isArray(raw.products)
      ? raw.products.map(normalizeSku).filter((sku) => sku !== 'all')
      : [];
    return {
      id: String(raw.id || `${raw.name}-${postal}`).slice(0, 80),
      name: kind === 'voila' ? 'Voilà' : String(raw.name),
      banner: extra ? (kind === 'lufa' ? 'Lufa' : 'Voilà') : String(raw.banner || raw.type || ''),
      channel: kind ? 'online' : String(raw.channel || 'grocery'),
      address: extra ? extra.address : String(raw.address || ''),
      city: extra ? extra.city : String(raw.city || ''),
      province: String(raw.province || 'QC'),
      postal,
      lat,
      lng,
      approx,
      hours: String(raw.hours || ''),
      openHour: raw.openHour == null ? null : Number(raw.openHour),
      closeHour: raw.closeHour == null ? null : Number(raw.closeHour),
      products,
      url: extra ? extra.url : raw.url || '',
    };
  }

  function loadStores(apiUrl) {
    if (!apiUrl) return Promise.resolve(uniqueStoreIds(MOCK_STORES));
    if (storeRequests.has(apiUrl)) return storeRequests.get(apiUrl);
    const request = fetchJson(apiUrl)
      .catch(() => fetchJsonp(apiUrl))
      .then((data) => {
        const rows = Array.isArray(data) ? data : data && data.stores;
        const mapped = (rows || []).map(normalizeApiStore).filter(Boolean);
        if (!mapped.length) throw new Error('stores-empty');
        return uniqueStoreIds(mapped);
      })
      .catch((error) => {
        storeRequests.delete(apiUrl);
        throw error;
      });
    storeRequests.set(apiUrl, request);
    return request;
  }

  // Source IDs occasionally repeat, including entries with different addresses.
  // Preserve every supplied record without letting markers overwrite each other.
  function uniqueStoreIds(stores) {
    const used = new Set();
    return stores.map((store) => {
      let id = store.id, suffix = 2;
      while (used.has(id)) id = `${store.id}--${suffix++}`;
      used.add(id);
      return id === store.id ? { ...store } : { ...store, id };
    });
  }

  function haversine(a, b) {
    const r = 6371;
    const dLat = ((b.lat - a.lat) * Math.PI) / 180;
    const dLng = ((b.lng - a.lng) * Math.PI) / 180;
    const s =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
    return 2 * r * Math.asin(Math.min(1, Math.sqrt(s)));
  }

  function formatKm(n, template, locale) {
    const value = new Intl.NumberFormat(locale, {
      minimumFractionDigits: n < 10 ? 1 : 0,
      maximumFractionDigits: n < 10 ? 1 : 0,
    }).format(n);
    return String(template || '__N__ km')
      .replace(/__N__/g, value)
      .replace(/\{\{\s*n\s*\}\}/g, value);
  }

  function formatPostal(value) {
    const compact = String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 6);
    if (compact.length <= 3) return compact;
    return `${compact.slice(0, 3)} ${compact.slice(3)}`;
  }

  function originFromPostal(raw) {
    const formatted = formatPostal(raw);
    const compact = formatted.replace(/\s/g, '');
    if (!POSTAL_RE.test(formatted) && !POSTAL_RE.test(compact)) return null;
    const fsa = compact.slice(0, 3);
    const pair = FSA[fsa] || LETTER_FALLBACK[fsa[0]];
    if (!pair) return { ...MONTREAL, label: formatted };
    return { lat: pair[0], lng: pair[1], label: formatted };
  }

  function inCanada(lat, lng) {
    return lat > 41 && lat < 84 && lng < -50 && lng > -141;
  }

  function geocodePostal(raw) {
    const fallback = originFromPostal(raw);
    if (!fallback) return Promise.resolve(null);
    const formatted = fallback.label;
    if (POSTAL_GEO_CACHE[formatted]) return Promise.resolve(POSTAL_GEO_CACHE[formatted]);

    const q = encodeURIComponent(`${formatted}, Québec, Canada`);
    return fetch(`https://photon.komoot.io/api/?q=${q}&limit=1&lat=45.5&lon=-73.6`, { credentials: 'omit' })
      .then((res) => {
        if (!res.ok) throw new Error('geo');
        return res.json();
      })
      .then((data) => {
        const coords = data && data.features && data.features[0] && data.features[0].geometry && data.features[0].geometry.coordinates;
        if (!coords || coords.length < 2) return fallback;
        const lng = Number(coords[0]);
        const lat = Number(coords[1]);
        if (!inCanada(lat, lng)) return fallback;
        const origin = { lat, lng, label: formatted };
        POSTAL_GEO_CACHE[formatted] = origin;
        return origin;
      })
      .catch(() => fallback);
  }

  function isOpenNow(store, now) {
    if (store.channel === 'online') return true;
    if (store.openHour == null || store.closeHour == null || !Number.isFinite(store.openHour) || !Number.isFinite(store.closeHour)) {
      return null;
    }
    const day = now.getDay();
    const hour = now.getHours() + now.getMinutes() / 60;
    const close = day === 0 ? Math.min(store.closeHour, 18) : store.closeHour;
    const open = day === 0 ? Math.max(store.openHour, 10) : store.openHour;
    return hour >= open && hour < close;
  }

  function unescapeHtml(value) {
    return String(value || '')
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function t(i18n, key, vars) {
    let out = (i18n && i18n[key]) || key;
    if (vars) {
      Object.keys(vars).forEach((name) => {
        const value = String(vars[name]);
        out = out.replace(new RegExp(`\\{\\{\\s*${name}\\s*\\}\\}`, 'g'), value);
        out = out.replace(new RegExp(`__${name.toUpperCase()}__`, 'g'), value);
      });
    }
    return out;
  }

  function whenMap() {
    if (window.L && (window.L.maplibreGL || window.maplibregl)) return Promise.resolve(window.L);
    return new Promise((resolve, reject) => {
      let tries = 0;
      const timer = window.setInterval(() => {
        tries += 1;
        if (window.L && (window.L.maplibreGL || window.maplibregl)) {
          window.clearInterval(timer);
          resolve(window.L);
        } else if (tries > 80) {
          window.clearInterval(timer);
          if (window.L) resolve(window.L);
          else reject(new Error('leaflet'));
        }
      }, 50);
    });
  }

  class GbStoreLocator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const loadToken = this._loadToken = (this._loadToken || 0) + 1;
      this._events = new AbortController();
      const events = { signal: this._events.signal };

      this.i18n = {};
      this.locale = document.documentElement.lang || 'fr-CA';
      const i18nEl = this.querySelector('[data-gb-locator-i18n]');
      if (i18nEl) {
        try {
          const parsed = JSON.parse(i18nEl.textContent);
          Object.keys(parsed).forEach((key) => {
            this.i18n[key] = unescapeHtml(parsed[key]);
          });
        } catch (err) {
          this.i18n = {};
        }
      }

      this.productLabels = {
        saucisse: t(this.i18n, 'productSaucisse'),
        minis: t(this.i18n, 'productMinis'),
        popcorn: t(this.i18n, 'productPopcorn'),
        pizza: t(this.i18n, 'productPizza'),
        burger: t(this.i18n, 'productBurger'),
      };
      this.categoryLabels = {
        'Épicerie': t(this.i18n, 'categoryGrocery'),
        'Institution': t(this.i18n, 'categoryInstitution'),
        'Restaurant/Bar': t(this.i18n, 'categoryRestaurant'),
        'Traiteur': t(this.i18n, 'categoryCaterer'),
        'Vaisseau Mère': t(this.i18n, 'categoryMothership'),
      };

      this.form = this.querySelector('[data-locator-form]');
      this.input = this.querySelector('[data-locator-input]');
      this.nearBtn = this.querySelector('[data-locator-near]');
      this.status = this.querySelector('[data-locator-status]');
      this.error = this.querySelector('[data-locator-error]');
      this.list = this.querySelector('[data-locator-list]');
      this.mapEl = this.querySelector('[data-locator-map]');
      this.card = this.querySelector('[data-locator-card]');
      this.submitBtn = this.querySelector('[data-locator-submit]');
      this.summary = this.querySelector('[data-locator-summary]');
      this.mapWrap = this.querySelector('.store-locator__mapwrap');
      this.viewButtons = [...this.querySelectorAll('[data-locator-view-button]')];
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.view = 'map';
      this.classList.remove('is-mapless', 'has-selection');
      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => this.setView(button.getAttribute('data-locator-view-button')), events);
      });
      this.mobileQuery.addEventListener('change', () => this.syncView(), events);
      this.classList.add('is-explorer-ready');
      this.syncView();

      this.stores = [];
      this.visible = [];
      this.filteredStores = [];
      this.filteredById = new Map();
      this.selectedId = null;
      this.channel = 'all';
      this.sku = 'all';
      this.origin = { ...MONTREAL };
      this.hasQuery = false;
      this.markers = {};
      this.map = null;
      this.markerLayer = null;
      this.apiUrl = (this.getAttribute('data-stores-url') || '').trim();
      this.pinIconUrl = (this.getAttribute('data-pin-icon') || '').trim();
      this.mapStyleUrl = (this.getAttribute('data-map-style') || '').trim();
      this.matchedCount = 0;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.searchPostal();
      }, events);

      this.input.addEventListener('input', () => {
        const cursor = this.input.selectionStart;
        const before = this.input.value;
        const formatted = formatPostal(before);
        if (formatted !== before) {
          this.input.value = formatted;
          const next = Math.min(formatted.length, (cursor || 0) + (formatted.length - before.length));
          this.input.setSelectionRange(next, next);
        }
        this.clearError();
      }, events);

      this.nearBtn.addEventListener('click', () => this.searchNear(), events);

      this.list.addEventListener('click', (event) => {
        const item = event.target.closest('[data-store-id]');
        if (!item) return;
        this.select(item.getAttribute('data-store-id'), { fly: true, scroll: false });
      }, events);

      this.list.addEventListener('keydown', (event) => {
        if (event.target.closest('a, button, input')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const item = event.target.closest('[data-store-id]');
        if (!item) return;
        event.preventDefault();
        this.select(item.getAttribute('data-store-id'), { fly: true, scroll: false });
      }, events);

      loadStores(this.apiUrl)
        .then((stores) => {
          if (!this.isConnected || loadToken !== this._loadToken) return;
          this.stores = stores.map((store) => {
            const kind = onlineKind(store);
            if (store.channel !== 'online' || !['lufa', 'voila'].includes(kind)) return store;
            return { ...store, address: t(this.i18n, `${kind}Address`), city: t(this.i18n, `${kind}City`) };
          });
          return whenMap()
            .then(() => {
              if (this.isConnected && loadToken === this._loadToken) this.initMap();
            })
            .catch(() => {
              this.classList.add('is-mapless');
              this.setView('list');
            });
        })
        .then(() => {
          if (!this.isConnected || loadToken !== this._loadToken) return;
          const params = new URLSearchParams(window.location.search);
          const fromUrl = normalizeSku(params.get('sku') || params.get('product'));
          if (fromUrl !== 'all') this.sku = fromUrl;
          this.refresh({ fit: true });
        })
        .catch(() => {
          if (!this.isConnected || loadToken !== this._loadToken) return;
          this.stores = [];
          this.classList.add('is-mapless');
          this.setView('list');
          this.setError(t(this.i18n, 'loadError'));
          if (this.status) this.status.textContent = t(this.i18n, 'empty');
        });
    }

    disconnectedCallback() {
      this._loadToken = (this._loadToken || 0) + 1;
      this._events?.abort();
      this._ro?.disconnect();
      window.clearTimeout(this._sizeTimer);
      window.clearTimeout(this._viewTimer);
      window.clearTimeout(this._searchTimer);
      this.markerLayer?.clearLayers();
      this.map?.remove();
      this.map = null;
      this.markerLayer = null;
      this.markers = {};
      this._ready = false;
    }

    reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    setView(view) {
      this.view = view === 'list' ? 'list' : 'map';
      this.syncView();
    }

    syncView() {
      const mapless = this.classList.contains('is-mapless');
      if (mapless) this.view = 'list';
      this.setAttribute('data-locator-view', this.view);
      this.viewButtons.forEach((button) => {
        const isMap = button.getAttribute('data-locator-view-button') === 'map';
        button.setAttribute('aria-pressed', String(button.getAttribute('data-locator-view-button') === this.view));
        button.disabled = mapless && isMap;
      });
      if (this.mapWrap) {
        const hidden = Boolean(this.mobileQuery.matches && this.view === 'list');
        this.mapWrap.inert = hidden;
        if (hidden) this.mapWrap.setAttribute('aria-hidden', 'true');
        else this.mapWrap.removeAttribute('aria-hidden');
      }
      window.clearTimeout(this._sizeTimer);
      this._sizeTimer = window.setTimeout(() => this.map?.invalidateSize({ animate: false }), 80);
    }

    initMap() {
      const L = window.L;
      if (typeof L.markerClusterGroup !== 'function') throw new Error('marker-cluster');
      this.map = L.map(this.mapEl, {
        scrollWheelZoom: false,
        zoomControl: false,
        attributionControl: true,
        minZoom: 2,
        maxZoom: 18,
      }).setView([this.origin.lat, this.origin.lng], 12);

      this.markerLayer = L.markerClusterGroup({
        maxClusterRadius: 48,
        showCoverageOnHover: false,
        removeOutsideVisibleBounds: true,
        chunkedLoading: true,
        chunkInterval: 24,
        chunkDelay: 16,
        animate: !this.reduceMotion(),
        spiderfyDistanceMultiplier: 1.4,
        iconCreateFunction: (cluster) => {
          const count = cluster.getChildCount();
          const label = t(this.i18n, 'clusterLabel', { n: count });
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gb-map-cluster';
          button.setAttribute('aria-label', label);
          button.textContent = count;
          // The inner native button supplies the keyboard interaction.
          cluster.options.keyboard = false;
          return L.divIcon({ className: 'gb-map-cluster-wrap', html: button, iconSize: [44, 44], iconAnchor: [22, 22] });
        },
      }).addTo(this.map);
      this.map.on('moveend', () => {
        window.clearTimeout(this._viewTimer);
        this._viewTimer = window.setTimeout(() => this.updateViewport(), 100);
      });

      L.control.zoom({ position: 'topright' }).addTo(this.map);
      if (typeof L.maplibreGL === 'function') {
        if (this.mapStyleUrl) this.map.attributionControl.addAttribution('<a href="https://github.com/maputnik/osm-liberty" target="_blank" rel="noopener">OSM Liberty</a>');
        L.maplibreGL({
          style: this.mapStyleUrl || 'https://tiles.openfreemap.org/styles/liberty',
          interactive: false,
          attribution: '&copy; OpenStreetMap &copy; OpenFreeMap · <a href="https://github.com/maputnik/osm-liberty" target="_blank" rel="noopener">OSM Liberty</a>',
        }).addTo(this.map);
      } else {
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap',
          maxZoom: 19,
        }).addTo(this.map);
      }

      this.map.scrollWheelZoom.enable();
      this._sizeTimer = window.setTimeout(() => this.map?.invalidateSize(), 80);
      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(() => {
          if (this.map) this.map.invalidateSize();
        });
        this._ro.observe(this.mapEl);
      }
    }

    syncMarkers(rows) {
      if (!this.map || !this.markerLayer || !window.L) return;
      const L = window.L;
      const keep = {};
      const added = [], removed = [];
      rows.forEach((row) => {
        const store = row.store;
        if (store.channel === 'online') return;
        keep[store.id] = true;
        if (!this.markers[store.id]) {
          const attribute = (value) => String(value).replace(/[&<>"']/g, (char) => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
          })[char]);
          const image = this.pinIconUrl
            ? `<img src="${attribute(this.pinIconUrl)}" alt="" width="30" height="30" draggable="false">`
            : '';
          const icon = L.divIcon({
            className: 'gb-pin-wrap',
            html: `<button type="button" class="gb-pin${image ? ' gb-pin--alien' : ''}" data-pin="${attribute(store.id)}" aria-label="${attribute(store.name)}" aria-pressed="false">${image}</button>`,
            iconSize: image ? [32, 36] : [28, 28],
            iconAnchor: image ? [16, 34] : [14, 14],
          });
          const marker = L.marker([store.lat, store.lng], { icon, title: store.name, keyboard: false });
          marker.on('click', () => this.select(store.id));
          marker.on('add', () => this.syncPin(marker, store.id));
          this.markers[store.id] = marker;
          added.push(marker);
        }
      });
      Object.keys(this.markers).forEach((id) => {
        if (keep[id]) return;
        removed.push(this.markers[id]);
        delete this.markers[id];
      });
      if (removed.length) this.markerLayer.removeLayers(removed);
      if (added.length) this.markerLayer.addLayers(added);
    }

    setChannel(channel) {
      this.channel = channel || 'all';
      this.refresh({ fit: true });
    }

    setSku(sku) {
      this.sku = normalizeSku(sku);
      this.refresh({ fit: true });
    }

    searchPostal() {
      const raw = this.input.value.trim();
      if (!raw) {
        this.setError(t(this.i18n, 'invalidPostal'));
        this.input.focus();
        return;
      }
      if (!originFromPostal(raw)) {
        this.setError(t(this.i18n, 'invalidPostal'));
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus();
        return;
      }
      this.clearError();
      this.setBusy(true);
      geocodePostal(raw).then((origin) => {
        this.setBusy(false);
        if (!origin) {
          this.setError(t(this.i18n, 'invalidPostal'));
          this.input.focus();
          return;
        }
        this.input.value = origin.label;
        this.runSearch(origin);
      });
    }

    searchNear() {
      if (!navigator.geolocation) {
        this.setError(t(this.i18n, 'geoDenied'));
        return;
      }
      this.nearBtn.disabled = true;
      this.setBusy(true);
      this.clearError();
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.nearBtn.disabled = false;
          this.input.value = '';
          this.runSearch({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            label: t(this.i18n, 'nearLabel'),
          });
        },
        () => {
          this.nearBtn.disabled = false;
          this.setBusy(false);
          this.setError(t(this.i18n, 'geoDenied'));
        },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
      );
    }

    runSearch(origin) {
      this.origin = origin;
      this.hasQuery = true;
      this.clearError();
      this.setBusy(true);
      const wait = this.reduceMotion() ? 0 : 280;
      window.clearTimeout(this._searchTimer);
      this._searchTimer = window.setTimeout(() => {
        this.setBusy(false);
        this.refresh({ fit: true, pickFirst: true });
      }, wait);
    }

    refresh({ fit = false, pickFirst = false } = {}) {
      if (fit) {
        this.list.scrollTop = 0;
        this.list.scrollLeft = 0;
      }
      this.filteredStores = this.stores
        .filter((store) => this.channel === 'all' || store.channel === this.channel)
        .filter((store) => this.sku === 'all' || !(store.products || []).length || store.products.includes(this.sku) || (this.sku === 'minis' && store.products.includes('saucisse')));
      this.filteredById = new Map(this.filteredStores.map(store => [store.id, store]));
      const ranked = this.rankStores(this.filteredStores, this.origin);
      this.syncMarkers(ranked);
      if (this.selectedId && !this.filteredById.has(this.selectedId)) this.clearSelection();
      if (fit) this.fitMap(ranked);
      this.updateViewport();
      if (pickFirst && ranked.length) this.select(ranked[0].store.id, { fly: true });
    }

    rankStores(stores, origin) {
      const now = new Date();
      return stores.map(store => ({ store, km: haversine(origin, store), open: isOpenNow(store, now) }))
        .sort((a, b) => (a.store.channel === 'online') - (b.store.channel === 'online') || a.km - b.km);
    }

    updateViewport() {
      if (!this.isConnected) return;
      const bounds = this.map?.getBounds();
      const center = this.map?.getCenter() || this.origin;
      const stores = this.filteredStores.filter(store => store.channel === 'online' || !bounds || bounds.contains([store.lat, store.lng]));
      const ranked = this.rankStores(stores, center);
      const physical = ranked.filter(row => row.store.channel !== 'online');
      this.matchedCount = physical.length;
      this.visible = physical.slice(0, LIST_LIMIT).concat(ranked.filter(row => row.store.channel === 'online'));
      if (this.selectedId) {
        const store = this.filteredById.get(this.selectedId);
        if (!store || (bounds && store.channel !== 'online' && !bounds.contains([store.lat, store.lng]))) this.clearSelection();
      }
      this.renderList();
      this.renderStatus();
      if (this.selectedId) this.select(this.selectedId);
    }

    renderStatus() {
      const n = this.matchedCount;
      if (this.summary) this.summary.textContent = t(this.i18n, n === 1 ? 'summaryOne' : 'summaryMany', { n });
      const shown = this.visible.filter((row) => row.store.channel !== 'online').length;
      const online = this.visible.some((row) => row.store.channel === 'online');
      const nearest = this.visible.find((row) => row.store.channel !== 'online');
      const query = this.hasQuery ? this.origin.label : t(this.i18n, 'defaultArea');
      let msg;
      if (this.map) {
        msg = t(this.i18n, !n ? 'areaEmpty' : n === 1 ? 'areaCountOne' : 'areaCountMany', { n });
        if (n > shown) msg += ' ' + t(this.i18n, 'nearestOnly', { n: shown });
        if (n) msg += ' ' + t(this.i18n, 'distancesCenter');
        if (online) msg += ' ' + t(this.i18n, 'plusOnline');
        this.status.textContent = msg;
        return;
      }
      if (!n && !online) {
        msg = t(this.i18n, 'empty');
      } else if (n === 0) {
        msg = t(this.i18n, 'onlineOnly');
      } else if (this.hasQuery && nearest && nearest.km > 40) {
        msg = t(this.i18n, 'far', { query });
      } else if (n === 1) {
        msg = t(this.i18n, 'countOne', { query });
      } else {
        msg = t(this.i18n, 'countMany', { n, query });
      }
      if (n > shown) {
        msg += ' ' + t(this.i18n, 'nearestOnly', { n: shown });
      }
      if (online && n > 0) {
        msg += ' ' + t(this.i18n, 'plusOnline');
      }
      this.status.textContent = msg;
    }

    renderList() {
      const scrollLeft = this.list.scrollLeft || 0;
      const scrollTop = this.list.scrollTop || 0;
      this.list.replaceChildren();
      if (!this.visible.length) {
        const empty = document.createElement('li');
        empty.className = 'store-locator__empty';
        empty.textContent = t(this.i18n, 'emptyHint');
        this.list.appendChild(empty);
        return;
      }

      this.visible.forEach((row) => {
        const store = row.store;
        const li = document.createElement('li');
        li.className = 'store-locator__item';
        li.setAttribute('data-store-id', store.id);
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(store.id === this.selectedId));
        li.tabIndex = 0;
        if (store.id === this.selectedId) li.classList.add('is-active');

        const top = document.createElement('div');
        top.className = 'store-locator__item-top';

        const banner = document.createElement('span');
        banner.className = 'store-locator__banner';
        banner.textContent = this.categoryLabels[store.banner] || store.banner;

        const meta = document.createElement('div');
        meta.className = 'store-locator__item-meta';

        if (row.open === true || row.open === false) {
          const state = document.createElement('span');
          state.className = row.open ? 'store-locator__open' : 'store-locator__closed';
          state.textContent = row.open ? t(this.i18n, 'open') : t(this.i18n, 'closed');
          meta.appendChild(state);
        }

        if (store.channel === 'online') {
          const online = document.createElement('span');
          online.className = 'store-locator__km';
          online.textContent = t(this.i18n, 'online');
          meta.appendChild(online);
        } else {
          const km = document.createElement('span');
          km.className = 'store-locator__km';
          km.textContent = formatKm(row.km, t(this.i18n, 'km'), this.locale);
          meta.appendChild(km);
        }

        top.append(banner, meta);

        const name = document.createElement('div');
        name.className = 'store-locator__item-name';
        name.textContent = store.name;

        const address = document.createElement('div');
        address.className = 'store-locator__item-address';
        address.textContent = store.postal
          ? `${store.address}, ${store.city}`
          : `${store.address} · ${store.city}`;

        const hours = store.hours
          ? (() => {
              const el = document.createElement('div');
              el.className = 'store-locator__item-hours';
              el.textContent = t(this.i18n, 'hours', { hours: store.hours });
              return el;
            })()
          : null;

        const tags = (store.products || []).length
          ? (() => {
              const wrap = document.createElement('div');
              wrap.className = 'store-locator__tags';
              store.products.forEach((key) => {
                const tag = document.createElement('span');
                tag.className = 'store-locator__tag';
                tag.textContent = this.productLabels[key] || key;
                wrap.appendChild(tag);
              });
              return wrap;
            })()
          : null;

        const actions = document.createElement('div');
        actions.className = 'store-locator__item-actions';

        if (store.channel === 'online' && store.url) {
          const order = document.createElement('a');
          order.className = 'store-locator__link';
          order.href = store.url;
          order.target = '_blank';
          order.rel = 'noopener noreferrer';
          order.textContent = t(this.i18n, 'order');
          order.addEventListener('click', (event) => event.stopPropagation());
          actions.appendChild(order);
        } else {
          const dir = document.createElement('a');
          dir.className = 'store-locator__link';
          dir.href = this.directionsUrl(store);
          dir.target = '_blank';
          dir.rel = 'noopener noreferrer';
          dir.textContent = t(this.i18n, 'directions');
          dir.addEventListener('click', (event) => event.stopPropagation());
          actions.appendChild(dir);
        }

        li.append(top, name, address);
        if (hours) li.append(hours);
        if (tags) li.append(tags);
        li.append(actions);
        this.list.appendChild(li);
      });
      this.list.scrollLeft = scrollLeft;
      this.list.scrollTop = scrollTop;
    }

    renderCard(row) {
      this.classList?.toggle('has-selection', Boolean(row));
      this.card.replaceChildren();
      if (!row) {
        this.card.hidden = true;
        return;
      }
      this.card.hidden = false;
      this.card.setAttribute('role', 'region');
      const store = row.store;

      const kicker = document.createElement('p');
      kicker.className = 'store-locator__card-kicker';
      kicker.textContent = `${this.categoryLabels[store.banner] || store.banner} · ${formatKm(row.km, t(this.i18n, 'km'), this.locale)}`;

      const name = document.createElement('p');
      name.className = 'store-locator__card-name';
      name.textContent = store.name;

      const addr = document.createElement('p');
      addr.className = 'store-locator__card-addr';
      addr.textContent = `${store.address}, ${store.city}`;

      const go = document.createElement('a');
      go.className = 'store-locator__card-go';
      go.href = store.url || this.directionsUrl(store);
      go.target = '_blank';
      go.rel = 'noopener noreferrer';
      go.textContent = store.channel === 'online' ? t(this.i18n, 'order') : t(this.i18n, 'directions');

      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'store-locator__card-close';
      close.setAttribute('aria-label', t(this.i18n, 'closeStore'));
      close.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      close.addEventListener('click', () => {
        this.clearSelection();
        if (this.mobileQuery?.matches) this.viewButtons?.find(button => button.getAttribute('data-locator-view-button') === 'map')?.focus({ preventScroll: true });
      });
      this.card.append(close, kicker, name, addr, go);
    }

    select(id, { fly = false, scroll = false } = {}) {
      const store = this.filteredById.get(id);
      const row = this.visible.find((item) => item.store.id === id) || (store && this.rankStores([store], this.map?.getCenter() || this.origin)[0]);
      if (!row) return;
      if (fly && this.mobileQuery?.matches && row.store.channel !== 'online') this.setView('map');
      this.selectedId = id;
      this.list.querySelectorAll('.store-locator__item').forEach((el) => {
        const on = el.getAttribute('data-store-id') === id;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.syncPins();
      this.renderCard(row.store.channel === 'online' ? null : row);
      if (fly && this.mobileQuery?.matches && row.store.channel !== 'online') {
        this.card.tabIndex = -1;
        this.card.setAttribute('aria-label', row.store.name);
        this.card.focus({ preventScroll: true });
      }

      if (scroll) {
        const el = this.list.querySelector(`[data-store-id="${id}"]`);
        if (el) el.scrollIntoView({ block: 'nearest', behavior: this.reduceMotion() ? 'auto' : 'smooth' });
      }

      if (fly && this.map && row.store.channel !== 'online') {
        const zoom = Math.max(this.map.getZoom(), 14);
        if (this.reduceMotion()) this.map.setView([row.store.lat, row.store.lng], zoom);
        else this.map.flyTo([row.store.lat, row.store.lng], zoom, { duration: 0.7 });
      }
    }

    syncPins() {
      Object.keys(this.markers).forEach((id) => {
        this.syncPin(this.markers[id], id);
      });
    }

    syncPin(marker, id) {
      const pin = marker.getElement()?.querySelector('.gb-pin');
      if (!pin) return;
      pin.classList.toggle('is-active', id === this.selectedId);
      pin.setAttribute('aria-pressed', String(id === this.selectedId));
    }

    clearSelection() {
      this.selectedId = null;
      this.renderCard(null);
      this.syncPins();
      this.list.querySelectorAll('.store-locator__item.is-active').forEach(el => {
        el.classList.remove('is-active');
        el.setAttribute('aria-selected', 'false');
      });
    }

    fitMap(rows) {
      if (!this.map || !window.L) return;
      const pts = rows
        .filter((row) => row.store.channel !== 'online')
        .slice(0, 8)
        .map((row) => [row.store.lat, row.store.lng]);
      if (!pts.length) return;
      if (pts.length === 1) {
        this.map.setView(pts[0], 14);
        return;
      }
      this.map.fitBounds(pts, {
        paddingTopLeft: [28, 28],
        paddingBottomRight: [28, 120],
        maxZoom: 13,
      });
    }

    directionsUrl(store) {
      const q = [store.address, store.city, store.postal, store.province].filter(Boolean).join(', ');
      if (q) return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}`;
      return `https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`;
    }

    setBusy(on) {
      this.classList.toggle('is-busy', on);
      if (this.submitBtn) this.submitBtn.disabled = on;
      this.list.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    setError(message) {
      this.error.hidden = !message;
      this.error.textContent = message || '';
      if (message) this.input.setAttribute('aria-invalid', 'true');
    }

    clearError() {
      this.error.hidden = true;
      this.error.textContent = '';
      this.input.removeAttribute('aria-invalid');
    }
  }

  customElements.define('gb-store-locator', GbStoreLocator);
})();
